export default "__VITE_ASSET__2983fd58__"